
// This file acts as a bridge to provide the Firebase Functions instance 
// to shared code without importing the frontend-specific configuration file.

let functionsInstance: any = null;

export const setFunctionsInstance = (instance: any) => {
    functionsInstance = instance;
};

export const getFunctionsInstance = () => {
    return functionsInstance;
};
